<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <h2
        class="ml-5"
        style="
          color: #3b3636 !important;
          text-align: start;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          margin-left: 1.5rem;
        "
      >
        Bán hàng bằng QR động
      </h2>
      <div class="col-12 col-md-6 mt-1">
        <div class="container">
          <div class="row">
            <div
              class="d-flex justify-content-lg-start flex-column"
              style="
                text-align: start;
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                line-height: 2;
              "
            >
              <h3 style="color: #3b3636 !important">Tiết kiệm thời gian</h3>
              <span style="left: 0px">
                Bán hàng trên VPos, quét mã QR thanh toán, báo có ngay trên
                thiết bị</span
              >
              <br />
              <h3 style="color: #3b3636 !important">
                Hoạt động trên mọi thiết bị
              </h3>
              <span style="left: 0px">
                Vpos hoạt động trên máy tính, điện thoại, máy tính bảng, máy bán
                hàng tự động</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mt-1">
        <div class="container">
          <div class="row">
            <div
              class="d-flex justify-content-lg-start flex-column"
              style="
                text-align: start;
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                line-height: 2;
              "
            >
              <h3 style="color: #3b3636 !important">QR động</h3>
              <span style="left: 0px"
                >Sinh QR động theo quy chuẩn VietQR của ngân hàng nhà nước cho
                đơn hàng</span
              >
              <br />
              <h3 style="color: #3b3636 !important">
                Quản lý thuận tiện
              </h3>
              <span style="left: 0px">
                Dễ dàng tra cứu từng đơn hàng, giao dịch của của hàng hoặc hệ
                thống</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="d-flex flex-column m-auto justify-content-center">
         
          <img :src="imageUrls.iconBannerVpos" class="mt-3" />
          <div class="d-flex m-auto"> 
            <div> <img
            :src="imageUrls.qrVpos"
            style="width: 130px"
            class="m-auto mt-4"
          /> </div>
         
          <div class="d-flex flex-column mt-4"> 
            <h3 style="color: #3b3636 !important ;  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">Tải ứng dụng</h3>
            <img
            :src="imageUrls.downloadIos"
            style="width: 130px"
            class="m-auto "
          />
          <img
            :src="imageUrls.downloadAndroid"
            style="width: 130px"
            class="m-auto "
          />
          </div>
        </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mt-5">
        <div class="container mt-5" style="height: auto">
          <div class="row">
            <div
              class="d-flex justify-content-lg-start flex-column"
              style="
                text-align: end;
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                line-height: 2;
              "
            >
              <h3 style="color: #3b3636 !important">Đăng ký</h3>
              <span style="left: 0px"
                >Chỉ cần Số điện thoại/Email và tài khoản ngân hàng</span
              >
              <br />
              <h3 style="color: #3b3636 !important">Tạo cửa hàng</h3>
              <span style="left: 0px"
                >Tên cửa hàng, địa chỉ, điện thoại, email, logo, ảnh, tài khoản
                ngân hàng, hạn mức</span
              >
              <br />
              <h3 style="color: #3b3636 !important">Phân quyền</h3>
              <span>Quyền tra cứu và Quyền thay đổi </span>
              <span style="left: 0px"
                >Những số điện thoại/Email được chủ cửa hàng cho phép thay
                đổi/tra cứu thông tin Cửa hàng và Sản phẩm, dịch vụ</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="slideshow-container">
          <div v-for="(slide, index) in slides" :key="index" class="mySlides">
            <div class="numbertext">{{ index + 1 }} / {{ slides.length }}</div>
            <div class="column">
              <img
                :src="slide.image"
                style="
                  width: 270px;
                  border: 5px #d5dbe1 solid;
                  border-radius: 35px;
                "
                class="hover-shadow cursor"
              />
            </div>
            <div class="text">{{ slide.caption }}</div>
          </div>

          <!-- <a class="prev" @click="plusSlides(-1)">❮</a>
          <a class="next" @click="plusSlides(1)">❯</a> -->
        </div>
        <br />

        <div style="text-align: center">
          <span
            v-for="(slide, index) in slides"
            :key="index"
            class="dot"
            @click="currentSlide(index + 1)"
            :class="{ active: slideIndex === index }"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { imageUrls } from "@/components/js/urlImg";

export default {
  data() {
    return {
      imageUrls: imageUrls,
      slideIndex: 0,
      slides: [
        { image: imageUrls.img1, caption: "" },
        { image: imageUrls.img2, caption: "" },
        { image: imageUrls.img3, caption: "" },
        { image: imageUrls.img4, caption: "" },
        { image: imageUrls.img5, caption: "" },
        { image: imageUrls.img6, caption: "" },
        { image: imageUrls.img7, caption: "" },
        { image: imageUrls.img8, caption: "" },
      ],
    };
  },
  mounted() {
    this.showSlides(this.slideIndex);
  },
  methods: {
    plusSlides(n) {
      this.showSlides((this.slideIndex += n));
    },
    currentSlide(n) {
      this.showSlides((this.slideIndex = n - 1));
    },
    showSlides(n) {
      let i;
      const slides = document.getElementsByClassName("mySlides");
      const dots = document.getElementsByClassName("dot");
      if (n >= slides.length) {
        this.slideIndex = 0;
      }
      if (n < 0) {
        this.slideIndex = slides.length - 1;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex].style.display = "block";
      dots[this.slideIndex].className += " active";
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
body {
  font-family: Verdana, sans-serif;
  margin: 0;
}
.mySlides {
  display: none;
}
img {
  vertical-align: middle;
}

/* Slideshow container */
.slideshow-container {
  max-width: 1000px;
  position: relative;
  margin: auto;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 10px;
  /* margin-top: -22px; */
  color: white;
  font-weight: bold;
  margin-right: 10%;
  margin-left: -40%;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: rgba(57, 148, 238, 0.8);
  border-radius: 10px;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
  border-radius: 10px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active,
.dot:hover {
  background-color: #717171;
}

/* Fading animation */

/* On smaller screens, decrease text size */
@media only screen and (max-width: 300px) {
  .prev,
  .next,
  .text {
    font-size: 11px;
  }
}
</style>